import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { filter, map, mergeMap } from 'rxjs/operators';
import { LoaderService } from './core/services/loader.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private readonly PROJECT_NAME = 'KISNA-CDB';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    public _loaderService: LoaderService
  ) { }

  ngOnInit() {
    this._loaderService.setDefaultIndicatorSourceUrl();

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd),
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        mergeMap(route => route.data)
      ).subscribe(data => {
        const pageTitle = data['title'];
        const fullTitle = pageTitle ? `${this.PROJECT_NAME} | ${pageTitle}` : this.PROJECT_NAME;
        this.titleService.setTitle(fullTitle);
      });
  }
}
